import { ConfigProvider } from "antd";
import { Route, Routes } from "react-router-dom";
import routes from "@/utils/routes";
import "./styles/style.css";
import PTSLayout from "./layouts/PTSLayout";
import { PtsZulipUnreadProvider } from "./context/PtsZulipUnreadContext";
import NotFoundPage from "@/pages/NotFoundPage";
import PTSNavigationRoutes from "./utils/navigationRoutes";
import PTSRoutes from "./utils/routes";
import { PTSTheme } from "./utils/PTSTheme";

import { ProtectedPTSRoute } from "./components/ProtectedPTSRoute";

/** A1 (Architecture One) protected routes - same pages as main app */
const a1AuthRoutes = routes.find(m => m.type === "auth")?.routes ?? [];

/** All routes inside PTS layout: A1 pages (schemas, tenant, workflow, etc.) + PTS pages (employee, projects, etc.) */
const allPTSContentRoutes = [
  ...a1AuthRoutes.map(({ path, element }) => ({ path, component: element })),
  ...Object.values(PTSRoutes).map(({ path, component }) => ({
    path,
    component,
  })),
];

const Pts = () => {
  return (
    <ConfigProvider
      theme={{
        hashed: false,
        ...PTSTheme,
      }}
    >
      <div className="pts-app">
        <Routes>
          <Route
            element={
              <PtsZulipUnreadProvider>
                <PTSLayout />
              </PtsZulipUnreadProvider>
            }
          >
            {/* {Object.values(PTSRoutes).map(({ path, component: Page }) => ( */}
            {allPTSContentRoutes.map(({ path, component: Page }) => (
              // <Route key={path} path={path} element={<Page />} />  old path without protected route
              <Route
                key={path}
                path={path}
                element={
                  <ProtectedPTSRoute>
                    <Page />
                  </ProtectedPTSRoute>
                }
              />
            ))}
          </Route>
          {/* 404 without sidebar/navbar - outside PTSLayout */}
          <Route
            path="*"
            element={
              <NotFoundPage
                buttonLink={PTSNavigationRoutes.EMPLOYEE_DASHBOARD}
              />
            }
          />
        </Routes>
      </div>

      {/* <Routes>
        {Object.values(PTSRoutes).map(({ path, component: Page }) => (
          <Route key={path} path={path} element={<Page />} />
        ))}
      </Routes> */}
    </ConfigProvider>
  );
};

export default Pts;
